import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { buttonBaseStyles } from "@tSurya/theme/mixins";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import { css, withTheme } from "styled-components";

const buttonType = {
    solid: "solid",
    outline: "outline",
    tertiary: "tertiary",
};

const baseProps = {
    activeMode: "darken",
    sizeVariant: "medium",
    typographyProps: {
        weight: TYPOGRAPHY.weight.base,
        size: TYPOGRAPHY.size.smaller,
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            line-height: 32px;
            border-radius: 0px;
        `,
    },
    shape: "rectangle",
    css: buttonBaseStyles(buttonType.solid),
};

// MGBW uses primary brand color for buttons; Surya/GV use darkmagenta
const getPrimaryButtonColor = () => isThemeActive(THEME_IDS.MGBW) ? COLORS.primary.base : COLORS.darkmagenta;

export default {
    primary: {
        ...baseProps,
        color: getPrimaryButtonColor(),
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.solid),
    },
    secondary: {
        ...baseProps,
        color: getPrimaryButtonColor(),
        buttonType: buttonType.outline,
        css: buttonBaseStyles(buttonType.outline),
    },
    link: {
        ...baseProps,
        background: COLORS.text.link,
        buttonType: buttonType.outline,
        css: buttonBaseStyles(buttonType.outline),
    },
    tertiary: {
        ...baseProps,
        background: "primary.base",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.tertiary),
    },
    defaultProps: {
        css: buttonBaseStyles(buttonType.solid),
    },
};
